const appTopbarDictIT = {
  welcome: "Benvenuto",
  editProfile: "Modifica Profilo",
  logout: "Disconnettersi",
  cancelAccount: "Annulla Account",
  writeCancelToConfirm: 'Scrivi "CANCELLARE" per confermare',
  confirmYourPassword: "Conferma la tua password",
  accountCanceledSuccessfully: "Account cancellato con successo! Sarai disconnesso a breve.",
  changePassword: "Cambiare la Password",
  currentPassword: "Password attuale",
  newPassword: "Nuova password",
  passwordChangedSuccessfully: "Password aggiornata correttamente!",
  upgradeAccount: "Upgrade di Piano",
  upgradeTo: "Upgrade",
  learnMoreAboutThePlan: "Saperne di più sul piano",
  upgradeWithVoucher: "Piano di upgrade con voucher",
  including: "inclusa",
  hello: "Ciao",
  myOrders: "I miei ordini",
};

export default appTopbarDictIT;

